import {
  TextField,
  Select
} from "@mui/material";
import { styled } from '@mui/material/styles';

// https://mui.com/material-ui/react-text-field/

const CssTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'var(--color-light)',
      borderWidth: 2,
    },
    '&:hover fieldset': {
      borderColor: 'var(--color-primary)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--color-primary)',
    },
  },
})

// MuiSelect-select 
// MuiSelect-outlined 
// MuiInputBase-input 
// MuiOutlinedInput-input

const CssSelect = styled(Select)({
  '& .MuiOutlinedInput-input': {
    border: '2px solid var(--color-light) !important',
    '&:hover': {
      border: '2px solid var(--color-primary) !important',
    }
  },
  '.MuiOutlinedInput-notchedOutline': {
    border: 'none !important'
  },
  '& .MuiList-root': {
    height: '200px'
  }
});

export { CssTextField, CssSelect };
